document.addEventListener("DOMContentLoaded", function () {
  const updateCartUI = () => {
    fetch("/cart.js")
      .then((res) => res.json())
      .then((cart) => {
        const counter = document.querySelector("#cst_cart-item-count");
        if (counter) counter.innerText = cart.item_count;

        document.dispatchEvent(new CustomEvent("cart:build"));
      })
      .catch((err) => console.error("not update on cart:", err));
  };

  const addToCartBtn = document.querySelector("[data-add-to-cart]");
  if (addToCartBtn) {
    addToCartBtn.addEventListener("click", function () {
      setTimeout(() => {
        updateCartUI();
        // Sepet çekmecesini açma olayını tetikle
        document.dispatchEvent(new CustomEvent("cart:open"));
      }, 1000);
    });
  }

  document.addEventListener("change", function (e) {
    if (e.target && e.target.matches("input[name='updates[]']")) {
      setTimeout(updateCartUI, 800);
    }
  });

  document.addEventListener("click", function (e) {
    if (
      e.target &&
      (e.target.classList.contains("qty__adjust--plus") ||
        e.target.classList.contains("qty__adjust--minus"))
    ) {
      setTimeout(updateCartUI, 800);
    }
  });
});
